const styles: any = (theme: any) => ({
  searchFields: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 100px',
    gridTemplateRows: '60px',
    '-ms-grid-columns': '1fr 1fr 1fr 100px',
    '-ms-grid-rows': '60px',
    alignItems: 'center',
    marginBottom: 16,
    '@media (max-width: 991px)': {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '60px 60px',
      '-ms-grid-columns': '1fr 1fr',
      '-ms-grid-rows': '60px 60px'
    },
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto auto auto auto',
      '-ms-grid-columns': '1fr',
      '-ms-grid-rows': '60px 60px 60px 60px'
    }
  },
  searchFieldsNoFilter: {
    display: 'grid',
    gridTemplateColumns: '1fr 0fr 1fr 100px',
    gridTemplateRows: '60px',
    '-ms-grid-columns': '1fr 1fr 1fr 100px',
    '-ms-grid-rows': '60px',
    alignItems: 'center',
    marginBottom: 16,
    '@media (max-width: 991px)': {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '60px 60px',
      '-ms-grid-columns': '1fr 1fr',
      '-ms-grid-rows': '60px 60px'
    },
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto auto auto auto',
      '-ms-grid-columns': '1fr',
      '-ms-grid-rows': '60px 60px 60px 60px'
    }
  },
  button: {
    width: 'auto',
    gridColumn: 4,
    gridRow: 1,
    alignSelf: 'center',
    '-ms-grid-row-align': 'center',
    '@media (max-width: 991px)': {
      gridRow: 2,
      gridColumn: 2
    },
    '@media (max-width: 769px)': {
      gridColumn: 1,
      gridRow: 4
    }
  }
});
export default styles;
